<template>
  <el-select
    v-model="Year"
    placeholder="Año"
    @change="handleSelection"
    v-bind="$attrs"
    size="mini"
    :disabled="disabled"
  >
    <el-option :key="0" :value="0" label="Todos"></el-option>
    <el-option
      v-for="item in years"
      :key="item"
      :label="item"
      :value="item"
    ></el-option>
  </el-select>
</template>

<script>
export default {
  name: "YearsComponent",
  props: {
    initial: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    specificYear: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      Year: new Date().getFullYear()
    };
  },
  computed: {
    years() {
      const lowLevel = this.initial > 0 ? this.initial : 2014;
      const currentYear = this.max > 0 ? this.max : new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 3; i++) {
        Years.push(i);
      }

      if (this.specificYear > 0) {
        Years.push(this.specificYear);
      }
      return Years;
    }
  },
  methods: {
    handleSelection() {
      this.$emit("change", this.Year);
    }
  }
};
</script>

<style scoped></style>
